var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gaming-pad-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.49989 11H10.4999M8.49989 9V13M15.4999 12H15.5099M18.4999 10H18.5099M10.9488 5H14.0509C16.6758 5 17.9883 5 19.0184 5.49743C19.9254 5.9354 20.679 6.63709 21.1805 7.51059C21.7501 8.5027 21.8436 9.81181 22.0306 12.43L22.2766 15.8745C22.3973 17.5634 21.0597 19 19.3664 19C18.5005 19 17.6794 18.6154 17.1251 17.9502L16.7499 17.5C16.4068 17.0882 16.2351 16.8823 16.0398 16.7159C15.6302 16.3672 15.1344 16.1349 14.6043 16.0436C14.3514 16 14.0834 16 13.5473 16H11.4525C10.9164 16 10.6484 16 10.3955 16.0436C9.86539 16.1349 9.36957 16.3672 8.96 16.7159C8.76463 16.8823 8.59305 17.0882 8.24989 17.5L7.87473 17.9502C7.3204 18.6154 6.49924 19 5.63335 19C3.94013 19 2.6025 17.5634 2.72314 15.8745L2.96918 12.43C3.15619 9.81181 3.2497 8.5027 3.81926 7.51059C4.32074 6.63709 5.07433 5.9354 5.98135 5.49743C7.01151 5 8.32396 5 10.9488 5Z",
    stroke: "#006400",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGame);
export default __webpack_public_path__ + "static/media/icon_game.e701dd213e4101486bd5430a74c85926.svg";
export { ForwardRef as ReactComponent };